import React from 'react';
import Page from '../../components-core/Page';
import Iconify from '../../components-core/Iconify';
import { TPayReport } from '../../sections/employee/settlement/TPayReport';
import { Card, CardContent, Tabs, Tab } from '@mui/material';
import BankStatements from '../../sections/employee/settlement/BankStatements';
import { DocumentRecord } from '../../sections/employee/settlement/DocumentRecord';
import { TemplateProductRecord } from '../../sections/employee/settlement/TemplateProductRecord';


const Settlement = () => {
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Page title="Rozrachunki">
      <Card>
        <CardContent>
          <Tabs value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
            <Tab label="wyciągi bankowe" icon={<Iconify icon="bx:money-withdraw" width={20} height={20} />}/>
            <Tab label="raporty tpay" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
            {/* <Tab label="Dokumenty rozliczeniowe" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
            <Tab label="Zdefiniowane pozycje faktur" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/> */}
          </Tabs>
          {currentTab === 0
            ? <BankStatements />
            : currentTab === 1
              ? <TPayReport />
              : null}
        </CardContent>
      </Card>
    </Page>
  );
};


export default Settlement;
